import * as msg from '../../helpers/console'
import proportional from '../../helpers/proportional'
import forms from '../../helpers/forms'
import setHeaderBlock from '../../components/setHeaderBlock'
import map from '../../components/map'

const init = () => {
  msg.success('ContactController', 'Ready!')
  new proportional().init()
  new forms().init()
  new setHeaderBlock().init()
  new map().init()
}

export default init
